export default __webpack_public_path__ + "static/media/team-7@2x.477888c3.png";